export class CustomerSelectorOptions {
  constructor(
    public readonly autoImpersonate: boolean,
    public readonly showTenantSelection: boolean
  ) {}
}
